// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import filterService from '../../../services/filterService/FilterService';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class PayoutEventsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'payoutEvents';
        this.Server = this.props.context.getState().server.payoutEvents;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['resourceId',];

        this.searchOp = filterService.OPERATORS.EQUAL;

        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'resourceId',
                label: 'resourceId',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'event',
                label: 'event',
                alignRight: false,
                cell: 'State',
                displayGrid: true
            },
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'payload',
                label: 'payload',
                alignRight: false,
                cell: 'Text',
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'response',
                label: 'response',
                alignRight: false,
                cell: 'Text',
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    customLogicOnMount = async () => {
        // const endDate = new Date();
        // const startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        // const lastWeek = formatDate(startDate, endDate);
        // this.dateRangeSave(lastWeek);
        const state = this.props.location?.state;
        const searchValue = state?.searchValue || '';
        if (searchValue) {
            await this.search(searchValue);
        }

    };
    renderCustomMenuItems() {
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>
        ];
    }
}
